export default {
  name: "ProAgePractice",
  props: {},
  emits: [],
  components: {},
  setup() {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    scroll() {
      const element = document.querySelector(".pro-age__format--title");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
          offset: { top: 30 },
        });
      }
    },
  },
};
